var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{ref:"subject",attrs:{"items":_vm.boards,"label":"Select Board","prepend-icon":"mdi-domain"},on:{"input":_vm.changeBoard},model:{value:(_vm.selectedBoardId),callback:function ($$v) {_vm.selectedBoardId=$$v},expression:"selectedBoardId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }